import { Badge } from "@/components/ui/badge";
import { RefreshCw } from "lucide-react";
import type { RecipientAutopayState } from "@/services/vendor-autopay.service";

interface AutopayStatusBadgeProps {
  state: RecipientAutopayState | null;
  recipientType: "individual" | "subs";
  recipientId: string;
}

export default function AutopayStatusBadge({ state, recipientType, recipientId }: AutopayStatusBadgeProps) {
  if (!state?.enabled) return null;

  const testId = `autopay-badge-${recipientType}-${recipientId}`;

  if (state.paused) {
    return (
      <Badge variant="destructive" className="gap-1 text-xs mt-1" data-testid={testId}>
        <RefreshCw className="h-3 w-3" />
        Autopay paused
      </Badge>
    );
  }

  if (state.lastRunStatus === "failed") {
    return (
      <Badge variant="destructive" className="gap-1 text-xs mt-1" data-testid={testId}>
        <RefreshCw className="h-3 w-3" />
        Autopay failed
      </Badge>
    );
  }

  return (
    <Badge variant="default" className="gap-1 text-xs mt-1" data-testid={testId}>
      <RefreshCw className="h-3 w-3" />
      Autopay
    </Badge>
  );
}
